import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlModalModule, BlFormModule } from '@blcloud/bl-ng-ui-component';
import { GenericPrintModule } from '@blcloud/bl-ng-share-module';
import { ReserveSearchConditionResource } from '@blcloud/bl-ng-resource';
import { ReservePrintModalComponent } from './reserve-print-modal.component';

/**
 * 予約印刷モーダルモジュール
 */
@NgModule({
  imports: [
    CommonModule,
    BlModalModule,
    BlFormModule,
    GenericPrintModule,
  ],
  exports: [
    ReservePrintModalComponent
  ],
  declarations: [
    ReservePrintModalComponent
  ],
  entryComponents: [
    ReservePrintModalComponent
  ]
})
export class ReservePrintModalModule {
  static forRoot(): ModuleWithProviders {
    return {
      ngModule: ReservePrintModalModule,
      providers: [
        GenericPrintModule.forRoot().providers,
        ReserveSearchConditionResource
      ]
    };
  }
}



// WEBPACK FOOTER //
// ./src/app/feature/reserve-print-modal/reserve-print-modal.module.ts